// export const PUBLIC_API_HOST =  '/back/';
export const PUBLIC_API_HOST =  '/';